module.exports = __webpack_public_path__ + "static/img/chengdou-bg.d8f5a86.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/introduce/chengdou-bg.jpg
// module id = BnFI
// module chunks = 1